module.exports = __webpack_public_path__ + "5f0da77cd87938f8f64c4eda6acca4ce.webp";